export class DataFetcherError<T> extends Error {
  constructor(
    public message: string,
    public url: string,
    public method: string,
    public status: number,
    public response: T
  ) {
    super(message);
    this.name = 'DataFetcherError';
  }
}

// Generated: https://chatgpt.com/share/67f16c85-65d0-8013-be1a-6492e20903bd
export function isDataFetcherError<T>(err: unknown): err is DataFetcherError<T> {
  return err instanceof DataFetcherError;
}
